// [ai] The providers, mounted once: TanStack (server data), the shell store, the player (its store + controller), the importer, Astra (its store + controller), the router.
// main.tsx builds them; tests build their own (src/test/render.tsx) with a memory router and a stubbed server.
import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import type { StoreApi } from "zustand";
import { PlayerContext } from "../player/context";
import { ImporterContext } from "../imports/ImportUI";
import type { Importer } from "../imports/importer";
import type { Astra } from "../chat/astra";
import { AstraContext } from "../chat/ChatUI";
import { ChatStoreContext } from "../stores/chat";
import { ImportsStoreContext } from "../stores/imports";
import type { Player } from "../player/player";
import { PlayerStoreContext } from "../stores/player";
import { ShellStoreContext, type ShellState } from "../stores/shell";
import { WidgetsContext, type Widgets } from "../widgets/widgets";
import { WidgetsStoreContext } from "../stores/widgets";

type Router = Parameters<typeof RouterProvider>[0]["router"];
export function App({ client, store, player, importer, astra, widgets, router }: { client: QueryClient; store: StoreApi<ShellState>; player: Player; importer: Importer; astra: Astra; widgets: Widgets; router: Router }) {
  return (
    <QueryClientProvider client={client}>
      <ShellStoreContext.Provider value={store}>
        <PlayerStoreContext.Provider value={player.store}><PlayerContext.Provider value={player}>
          <ImportsStoreContext.Provider value={importer.store}><ImporterContext.Provider value={importer}>
            <ChatStoreContext.Provider value={astra.store}><AstraContext.Provider value={astra}>
              <WidgetsStoreContext.Provider value={widgets.store}><WidgetsContext.Provider value={widgets}>
                <RouterProvider router={router} />
              </WidgetsContext.Provider></WidgetsStoreContext.Provider>
            </AstraContext.Provider></ChatStoreContext.Provider>
          </ImporterContext.Provider></ImportsStoreContext.Provider>
        </PlayerContext.Provider></PlayerStoreContext.Provider>
      </ShellStoreContext.Provider>
    </QueryClientProvider>
  );
}
